import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import './styles.css';

class numberIncrement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  // componentDidMount() {
  //   document.addEventListener('mousedown', this.handleClickOutside);
  // }

  // componentWillUnmount() {
  //   document.removeEventListener('mousedown', this.handleClickOutside);
  // }

  // /**
  //  * Set the wrapper ref
  //  */
  // setWrapperRef(node) {
  //   this.wrapperRef = node;
  // }

  // /**
  //  * Alert if clicked on outside of element
  //  */
  // handleClickOutside = event => {
  //   console.log(this);
  //   // this.props.input.onBlur(this.props.input.value);
  //   this[this.props.input.name].blur();
  // };

  // // old
  onHandlePlusClick = () => {
    this.props.input.onChange(++this.props.input.value);
    // this.props.input.onBlur(this.props.input.value);
    // this.input.blur();
  };

  onHandleMinusClick = () => {
    if (this.props.input.value === '0' || this.props.input.value === 0) return;
    this.props.input.onChange(--this.props.input.value);
    // this.props.input.onBlur(this.props.input.value);
    // this.input.blur();
  };

  handleMinusBlur = () => {
    this.props.input.onBlur(this.props.input.value);
    this.input.blur();
  };

  handlePlusBlur = () => {
    this.props.input.onBlur(this.props.input.value);
    this.input.blur();
  };

  // handleBlur = e => {
  //   console.log(e.target);
  //   this.props.input.onBlur(this.props.input.value);
  //   this.input.blur();
  // };

  render() {
    const { input, type, meta: { touched, error, warning } } = this.props;
    const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
    return (
      <div className="number-increment text-center">
        <div className="row" style={{ marginLeft: '-15px', marginRight: '-15px' }}>
          <div className="col-xs-12">
            <div className="input-group">
              <span className="input-group-btn">
                <Button bsStyle="link" onClick={this.onHandleMinusClick} onBlur={this.handleMinusBlur}>
                  <span className="glyphicon glyphicon-minus" />
                </Button>
              </span>
              <FormGroup readOnly controlId={input.name} validationState={validationState}>
                <div>
                  <FormControl
                    type={type}
                    {...input}
                    min="0"
                    inputRef={ref => {
                      this.input = ref;
                    }}
                  />
                  {touched && error && <span className="help-block">{error}</span>}
                </div>
              </FormGroup>
              <span className="input-group-btn">
                <Button bsStyle="link" onClick={this.onHandlePlusClick} onBlur={this.handlePlusBlur}>
                  <span className="glyphicon glyphicon-plus" />
                </Button>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(numberIncrement);



// WEBPACK FOOTER //
// ./src/components/numberIncrement/numberIncrement.js